<nz-progress
  nzType="circle"
  [nzWidth]="36"
  [nzPercent]="percent"
  [nzStrokeColor]="{
    '0%': '#49d638',
    '52%': '#ffce46',
    '100%': '#ff0000'
  }"
  [nzFormat]="progressFormat"
></nz-progress>

<div class="difference" [ngClass]="{ negative: isDifferenceNegative }">{{ difference }}%</div>
